import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';

import { Main, Filter } from 'Containers/';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { SIMPLE_AVERAGE_FORM_NAME } from 'Common/FormEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { SimpleAverageFieldEnum as Fields } from 'Common/FieldEnum';
import { MenuMealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';

import * as Selectors from './state/simpleaverage/selectors';
import * as Actions from './state/simpleaverage/actions';
import { SimpleAverageForm } from './components/SimpleAverageForm';

class SimpleAverage extends Component {
  currentDate = moment().format(DATE_FORMAT_FOR_UI);

  cycleMenuAll = 0;

  componentDidMount() {
    const { getCycleMenus } = this.props;
    getCycleMenus(
      this.currentDate,
      this.currentDate,
      'ALL',
      MenuMealTypesEnum.ALL
    );
  }

  componentDidUpdate(prevProps) {
    const { cycleMenus, change } = this.props;
    if (prevProps.cycleMenus.length !== cycleMenus.length) {
      change(
        SIMPLE_AVERAGE_FORM_NAME,
        Fields.CycleMenu,
        this.getCycleMenuValue()
      );
    }
  }

  get mainProps() {
    const { reportFetching } = this.props;
    return {
      toolbox: {
        formName: SIMPLE_AVERAGE_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching || this.props.loading,
        },
        shown: true,
      },
    };
  }

  handleSubmit = formValues => {
    const { getReport } = this.props;

    getReport('reports/SimpleAverage', formValues);
  };

  getCycleMenuValue = () => {
    const { cycleMenus } = this.props;
    switch (cycleMenus.length) {
      case 0:
        return null;
      case 1:
        return cycleMenus[0].Id;
      default:
        return this.cycleMenuAll;
    }
  };

  handleFormValuesChange = (values, dispatch, props, previousValues) => {
    const { getCycleMenus, change } = this.props;
    if (
      (values[Fields.FromDate] !== previousValues[Fields.FromDate] ||
        values[Fields.ToDate] !== previousValues[Fields.ToDate] ||
        values[Fields.Site] !== previousValues[Fields.Site] ||
        values[Fields.MealType] !== previousValues[Fields.MealType]) &&
      moment(values[Fields.toDate]).isAfter(moment(values[Fields.FromDate]))
    ) {
      getCycleMenus(
        values[[Fields.FromDate]],
        values[Fields.ToDate],
        values[Fields.Site],
        values[Fields.MealType]
      );

      if (values[Fields.Site] === 'ALL') {
        change(SIMPLE_AVERAGE_FORM_NAME, Fields.IncludeAllergyReport, false);
      }
    }
  };

  render() {
    const { cycleMenus, loading, reportFetching, formValues } = this.props;
    return (
      <Fragment>
        <Filter title="Simple Average" />
        <Main {...this.mainProps}>
          <SimpleAverageForm
            loading={loading}
            reportFetching={reportFetching}
            onSubmit={this.handleSubmit}
            cycleMenus={cycleMenus}
            onChange={this.handleFormValuesChange}
            selectedSite={formValues ? formValues[Fields.Site] : 'ALL'}
            initialValues={{
              [Fields.Site]: 'ALL',
              [Fields.FromDate]: this.currentDate,
              [Fields.ToDate]: this.currentDate,
              [Fields.MealType]: MenuMealTypesEnum.ALL,
              [Fields.ReimbursableItemsOnly]: false,
              [Fields.IncludeAllergyReport]: false,
              [Fields.CycleMenu]: this.getCycleMenuValue(),
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: Selectors.getLoading(state),
    cycleMenus: Selectors.getCycleMenus(state),
    formValues: getFormValues(SIMPLE_AVERAGE_FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  ...Actions,
  change,
};

SimpleAverage = withReportSubscription(SimpleAverage);
SimpleAverage = connect(mapStateToProps, mapDispatchToProps)(SimpleAverage);

export { SimpleAverage };



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/SimpleAverage.js